/**
 * Created by Victor Rojo on 3/9/18.
 */
import {Component, Input} from '@angular/core';

import {SectionMap} from "../../section/Section";
import {GadgetService} from "../../gadget/Gadget.service";
import {ElementGroupWidget} from "../../widget/Widget";
import {Widget, WidgetTypes} from "../../widget/Widget";
import {ElementGroupElement} from "../../element/Element";


@Component({
  selector: 'element-group',
  templateUrl: './ElementGroup.html',
  styleUrls: ['./ElementGroup.css']
})
export class ElementGroupComponent {
  private _elementGroupWidget: ElementGroupWidget;
  relevantElements: number;
  totalElements: number;
  elements: ElementGroupElement[];

  constructor(private gadgetService: GadgetService) {}

  get widget(): ElementGroupWidget {
    return this._elementGroupWidget;
  }

  @Input()
  set widget(elementGroupWidget: ElementGroupWidget) {
    this._elementGroupWidget = elementGroupWidget;
    this.updateValues(elementGroupWidget);
  }

  private updateValues(elementGroupWidget: ElementGroupWidget){
    this.relevantElements = elementGroupWidget.elements
      .map(this.getRelevantFunction(elementGroupWidget.widgetTypeId))
      .reduce(function(a,b){
        return a+b;
      });
    this.totalElements = elementGroupWidget.elements.length;
    this.elements = elementGroupWidget.elements
      .filter(this.getRowFilterFunction(elementGroupWidget.widgetTypeId))
      .sort(this.getRowSortFunction(elementGroupWidget.widgetTypeId));
  }

  private getRelevantFunction(widgetTypeId:number): (para:ElementGroupElement)=>number {
    switch (widgetTypeId) {
      case WidgetTypes.LIGHTS_ON:
      case WidgetTypes.NETWORK_DEVICES:
      case WidgetTypes.SOCKETS_ON:
      case WidgetTypes.STATUS_GROUP:
        return (element:ElementGroupElement) => element.status ? 1 : 0 ;
    }
  }

  private getRowFilterFunction(widgetTypeId:number) {
    switch (widgetTypeId) {
      case WidgetTypes.LIGHTS_ON:
      case WidgetTypes.SOCKETS_ON:
      case WidgetTypes.STATUS_GROUP:
        return (element:ElementGroupElement) => element.status ? true : false;
      case WidgetTypes.NETWORK_DEVICES:
        return (element:ElementGroupElement) => true ;
    }
  }

  private getRowSortFunction(widgetTypeId:number){
    switch (widgetTypeId) {
      case WidgetTypes.LIGHTS_ON:
      case WidgetTypes.NETWORK_DEVICES:
      case WidgetTypes.SOCKETS_ON:
      case WidgetTypes.STATUS_GROUP:
        return (e1:ElementGroupElement, e2:ElementGroupElement) => e2.lastStatusChange - e1.lastStatusChange ;
    }
  }

}
